/**
 * Dev sandbox alert for building the typed Signal Performance dashboard.
 * Only this alert skips the real HTML snapshot on the Dashboard tab.
 */
export const SIGNAL_DEV_ALERT_ID = "alert-c5b9967d14c6";

export function isSignalDevAlert(alertId: string | null | undefined): boolean {
  return alertId === SIGNAL_DEV_ALERT_ID;
}
